import React from "react";
import facebook from "../img/social/facebook.png";
import x from "../img/social/twitter.png";
import linkedin from "../img/social/in.png";
import whatsapp from "../img/social/whatsapp-utpl.png";

const SocialShare = ({ title, url }) => {
  // URLs de compartición por red social
  const socialLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      title
    )}&url=${encodeURIComponent(url)}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      url
    )}&title=${encodeURIComponent(title)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(
      title
    )}%20${encodeURIComponent(url)}`,
  };

  // Función para abrir la ventana de compartición
  const handleShare = (link) => {
    window.open(link, "_blank", "width=600,height=400");
  };

  return (
    <div className="wrapper-social-noticias">
      <button onClick={() => handleShare(socialLinks.whatsapp)}>
        <img src={whatsapp} alt="utpl"></img>
      </button>{" "}
      <button onClick={() => handleShare(socialLinks.twitter)}>
        {" "}
        <img src={x} alt="utpl"></img>
      </button>
      <button onClick={() => handleShare(socialLinks.linkedin)}>
        <img src={linkedin} alt="utpl"></img>
      </button>
      <button onClick={() => handleShare(socialLinks.facebook)}>
        <img src={facebook} alt="utpl"></img>
      </button>
    </div>
  );
};

export default SocialShare;
